import { render, staticRenderFns } from "./PurchaseRequisitionEditView.vue?vue&type=template&id=96817968"
import script from "./PurchaseRequisitionEditView.vue?vue&type=script&lang=js"
export * from "./PurchaseRequisitionEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports